import { NewBuildingProjectType } from "@/features/BuildingProject";

export const ProjectTemplate: NewBuildingProjectType = {
  builder: "",
  buildingTypeEnum: null,
  buildingProjectStageEnum: null,
  clientName: "",
  projectName: "",
  projectNumber: "",
  streamId: "",

  speckleConfiguration: {
    parameters: {
      classificationCode: "",
      classificationTypeId: "",
    },
  },

  specialConditionConfig: {
    enabled: false,
  },

  branches: [],

  buildingAddress: {
    street: "",
    streetNumber: "",
    postalCode: "",
    city: "",
    country: "",
  },
  numberOfPeople: null,

  transportTypes: [],

  emissionCalculationAssumptions: {
    calculationType: {
      // null, not 0: 0 is Denmark's Custom calculation type, a real choice. Seeding 0 made "nothing
      // chosen yet" and "Custom chosen" the same number, which is how the create flow came to skip
      // writing the calculation row for Custom projects (RTLCA-5595).
      calculationTypeEnum: null,
      considerationPeriod: null,
      extraThresholds: [],
      thresholdLimitWithoutExtra: null,
      installationThresholdLimit: null,
      useDefaultEmissions: false,
    },
    emissionMetaData: {
      yearOfCommissioning: new Date().getFullYear(),
      yearOfConstruction: new Date().getFullYear(),
      includedPhases: [],
      includedPhasesTranslated: [],
    },
    heatArea: {
      heatedFloorAreaAboveGround: null,
      heatedBasementArea: null,
    },
    wastagePercentage: 10,
    projectEnergyData: {
      constructional: {
        earthMoved: undefined,
        electricity: undefined,
        heat: undefined,
        machineryFuel: undefined,
      },
      operational: {
        electricity: undefined,
        heat: undefined,
      },
      operationExportedElectricity: null,
      validatedBy: "",
      validationDate: null,
    },
    referencedAreas: {
      values: {},
      entries: [],
      basementFloors: null,
      floorsAboveGround: null,
      areaAboveGround: null,
      areaBelowGround: null,
      totalArea: null,
    },
  },
};
